import styled, { css } from "styled-components";

const commonStyles = css`
  padding: 2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.tertiary};
  max-width: 95vw;
  width: 100rem;

  .textoOpcoesCorreios {
    text-align: left;
    padding: 1rem 0 4rem;
    width: 90%;
    color: ${(props) => props.theme.colors.tertiary};
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }
  }

  .opcoesAvancadasCorreios {
    padding: 1rem 0;
    .opcao {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      gap: 1rem;
    }
  }

  .dropdown {
    display: contents;
  }

  .titulo {
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 0;
  }

  .opcoesDeFrete {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 1rem 0;
    align-items: start;
    justify-content: space-between;
    position: relative;
    gap: 2rem;
    width: 100%;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 3rem 4rem;
    }

    .opcao-container{
      display: grid;
      grid-template-columns: 1fr;
      gap: 1rem;
      
      .opcao {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 1rem;
      }
    }
  }

  .embalagemContainer {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
    gap: 1rem;
    
    .containerInput {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
    }
  }

  .contratoComCorreios {
    position: relative;
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 1rem;
    margin-bottom: 1rem;

    .avancadas {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2rem 0 0 0;
      text-align: left;
      .input-aux-wrapper {
        top: 100%;
        position: absolute;
        .input-aux {
          width: 0;
          height: 0;
          background-color: rgba(0, 0, 0, 0);
          pointer-events: none;
        }
      }
    }

    .titulo {
      color: ${(props) => props.theme.colors.tertiary};
      font-weight: bold;
    }

    .grid-inputs {
      padding: 1rem 0;
      display: grid;
      width: 100%;
      grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
      gap: 1rem;
      .containerInput {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
      }
      
      .popoverCorreios {
        &::after {
          white-space: normal;
          width: 227px;
        }
      }
    }
  }

  @media (max-width: 590px) {
    .opcoesDeFrete {
      .opcao-container{
        display: flex;
        flex-direction: row;
        width: 25rem;
        .opcao {
          flex-direction: row-reverse;
          gap: 5rem;
          width: 100%;
          justify-content: space-between;
          padding: 0;
        }
        @media (max-width: 768px) {
          flex-direction: column;
          width: auto;
        }
      }
    }
    .embalagemContainer {
      padding: 0;
    }
  }
`;

const ContainerConfigCorreios = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      display: block;
      width: 100%;
      max-width: none;
      padding: 0 0rem;
      .textoOpcoesCorreios {
        padding: 3rem 0;
        width: 100%;
        &::after{
          bottom: -10px;
        }
      }
      .opcoesAvancadasCorreios {
        margin-top: 0;
        justify-content: flex-start;
        display: flex;
        padding: 1rem 0;
        .opcao {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          gap: 1rem;
        }
      }
      .contratoComCorreios {
        align-items: flex-start;
        width: 100%;
        .grid-inputs {
          width: 100%;
          grid-template-columns: repeat(auto-fit, minmax(40%, 1fr));
          gap: 1rem;
        }
      }
    `}
`;

export default ContainerConfigCorreios;
